module.exports = __webpack_public_path__ + "img/background-default.153a43f2.jpg";